import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getGroups ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice-group',
          func: 'read',
          id: store.state.authentication.requestId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async createGroup ({ state }, groupName) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice-group',
          func: 'create',
          id: store.state.authentication.requestId,
          groupName: groupName
        })
        return res.data.message
      } catch (ex) {
        console.log(ex)
        return false
      }
    },
    async updateGroup ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice-group',
          func: 'update',
          id: store.state.authentication.requestId,
          groupId: data.groupId,
          groupName: data.groupName,
          ...data.defaultVoice && {
            defaultVoice: data.defaultVoice
          }
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async deleteGroup ({ state }, groupId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice-group',
          func: 'delete',
          id: store.state.authentication.requestId,
          groupId: groupId
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getGroupItem ({ state }, groupId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice',
          func: 'read',
          id: store.state.authentication.requestId,
          groupId: groupId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getVoiceInfo ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice',
          func: 'voices',
          id: store.state.authentication.requestId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async previewVoice ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice',
          func: 'preview',
          id: store.state.authentication.requestId,
          voice: data.voice,
          text: data.text,
          speed: data.speed,
          pitch: data.pitch
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async createVoice ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice',
          func: 'create',
          id: store.state.authentication.requestId,
          groupId: data.groupId,
          voice: data.voice,
          text: data.text,
          speed: data.speed,
          pitch: data.pitch,
          defaultLang: data.defaultLang
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async updateVoice ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice',
          func: 'update',
          id: store.state.authentication.requestId,
          groupId: data.groupId,
          voice: data.voice,
          text: data.text,
          speed: data.speed,
          pitch: data.pitch
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async deleteVoice ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-smart-voice',
          func: 'delete',
          id: store.state.authentication.requestId,
          groupId: data.groupId,
          languageCode: data.languageCode
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
  }
}
